(function(){

/* ═══ HERO CANVAS ═══ */
var c=document.getElementById('ejHeroCanvas');
if(c){
  var ctx=c.getContext('2d'),W,H,nodes=[],mouse={x:-9999,y:-9999};
  var CONNECT_DIST=160,MOUSE_DIST=200,FRICTION=0.92;
  function rsz(){W=c.width=c.offsetWidth;H=c.height=c.offsetHeight}
  function mkN(){nodes=[];var n=Math.max(60,Math.floor(W*H/10000));for(var i=0;i<n;i++)nodes.push({x:Math.random()*W,y:Math.random()*H,ox:0,oy:0,vx:(Math.random()-.5)*.4,vy:(Math.random()-.5)*.4,r:Math.random()*1.8+0.8,p:Math.random()*Math.PI*2,speed:Math.random()*.015+.008})}
  var hero=c.closest('.ej-hero');
  if(hero){
    hero.addEventListener('mousemove',function(e){var r=c.getBoundingClientRect();mouse.x=e.clientX-r.left;mouse.y=e.clientY-r.top});
    hero.addEventListener('mouseleave',function(){mouse.x=-9999;mouse.y=-9999});
  }
  function draw(){
    ctx.clearRect(0,0,W,H);
    nodes.forEach(function(n){n.x+=n.vx;n.y+=n.vy;n.p+=n.speed;if(n.x<0||n.x>W)n.vx*=-1;if(n.y<0||n.y>H)n.vy*=-1;var dx=n.x-mouse.x,dy=n.y-mouse.y,dist=Math.sqrt(dx*dx+dy*dy);if(dist<MOUSE_DIST&&dist>0){var f=(1-dist/MOUSE_DIST)*0.06;n.ox+=dx/dist*f*18;n.oy+=dy/dist*f*18}n.ox*=FRICTION;n.oy*=FRICTION});
    for(var i=0;i<nodes.length;i++){var a=nodes[i],ax=a.x+a.ox,ay=a.y+a.oy;for(var j=i+1;j<nodes.length;j++){var b=nodes[j],bx=b.x+b.ox,by=b.y+b.oy,d=Math.hypot(ax-bx,ay-by);if(d<CONNECT_DIST){ctx.beginPath();ctx.moveTo(ax,ay);ctx.lineTo(bx,by);ctx.strokeStyle='rgba(100,140,230,'+(1-d/CONNECT_DIST)*0.28+')';ctx.lineWidth=0.7;ctx.stroke()}}var g=0.5+Math.sin(a.p)*0.5,mdx=ax-mouse.x,mdy=ay-mouse.y,md=Math.sqrt(mdx*mdx+mdy*mdy),bright=md<MOUSE_DIST?1-(md/MOUSE_DIST)*0.6:0;ctx.beginPath();ctx.arc(ax,ay,a.r+(bright*1.5),0,Math.PI*2);ctx.fillStyle='rgba('+(107+bright*60)+','+(142+bright*40)+',232,'+(g*0.7+bright*0.4)+')';ctx.fill();if(bright>0.3){ctx.beginPath();ctx.arc(ax,ay,a.r*3,0,Math.PI*2);ctx.fillStyle='rgba(120,160,255,'+(bright*0.12)+')';ctx.fill()}}
    requestAnimationFrame(draw);
  }
  window.addEventListener('resize',function(){rsz();mkN()});
  rsz();mkN();draw();
}

/* ═══ SCROLL ANIMATIONS ═══ */
var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('ej-visible');e.target.querySelectorAll('.ej-fade').forEach(function(el,i){el.style.transitionDelay=(i*70)+'ms';el.classList.add('ej-visible')})}})},{threshold:.1});
document.querySelectorAll('.ej-fade').forEach(function(el){obs.observe(el)});

/* Mobile: always reveal quote section intro when #ej-contact enters view */
(function(){
  if(!window.matchMedia('(max-width:749px)').matches)return;
  var contact=document.getElementById('ej-contact');
  if(!contact)return;
  function revealContactIntro(){
    contact.querySelectorAll('.ej-label, .ej-title, .ej-sub').forEach(function(el,i){
      el.style.transitionDelay=(i*70)+'ms';
      el.classList.add('ej-visible');
    });
  }
  if(location.hash==='#ej-contact')revealContactIntro();
  var contactObs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){if(e.isIntersecting)revealContactIntro()});
  },{threshold:0,rootMargin:'48px 0px'});
  contactObs.observe(contact);
})();

/* ═══ BUILD STEPS ANIMATION ═══ */
(function(){
  var track=document.getElementById('ejStepsTrack');
  var grid=document.getElementById('ejStepsGrid');
  var line=document.getElementById('ejStepsLine');
  var steps=document.querySelectorAll('.ej-step');
  if(!track||!grid||!line||!steps.length)return;
  var DURATION=7000,FILL_END=0.45,HOLD_END=0.65;
  var MOBILE_LINE_TOP=28;
  var running=false;
  function ease(t){return t<0.5?2*t*t:1-Math.pow(-2*t+2,2)/2}
  function getP(t){if(t<=FILL_END)return ease(t/FILL_END);if(t<=HOLD_END)return 1;return 1-ease((t-HOLD_END)/(1-HOLD_END))}
  function isMobileSteps(){return window.matchMedia('(max-width:749px)').matches}
  function updateMobileTimelineLength(){
    if(!isMobileSteps()){grid.style.removeProperty('--ej-steps-line-length');return}
    var lastNode=document.querySelector('.ej-step:last-child .ej-step-node');
    if(!lastNode)return;
    var gridRect=grid.getBoundingClientRect();
    var nodeRect=lastNode.getBoundingClientRect();
    var nodeCenter=nodeRect.top+nodeRect.height/2;
    var length=Math.max(0,Math.round(nodeCenter-gridRect.top-MOBILE_LINE_TOP));
    grid.style.setProperty('--ej-steps-line-length',length+'px');
  }
  function getMobileLineLength(){
    updateMobileTimelineLength();
    var length=parseFloat(getComputedStyle(grid).getPropertyValue('--ej-steps-line-length'));
    return isNaN(length)?0:length;
  }
  var start=null;
  function tick(ts){
    if(!start)start=ts;
    var t=((ts-start)%DURATION)/DURATION,p=getP(t);
    if(isMobileSteps()){
      line.style.width='';
      var lineLength=getMobileLineLength();
      line.style.height=(p*lineLength)+'px';
      var lineBottomEdge=line.getBoundingClientRect().bottom;
      steps.forEach(function(step){
        var nodeRect=step.querySelector('.ej-step-node').getBoundingClientRect();
        var nodeCenter=nodeRect.top+nodeRect.height/2;
        if(lineBottomEdge>=nodeCenter-2){step.classList.add('ej-step-active')}
        else{step.classList.remove('ej-step-active')}
      });
    }else{
      line.style.height='';
      line.style.width=(p*100)+'%';
      var lineRightEdge=line.getBoundingClientRect().right;
      steps.forEach(function(step){
        var nodeRect=step.querySelector('.ej-step-node').getBoundingClientRect();
        var nodeCenter=nodeRect.left+nodeRect.width/2;
        if(lineRightEdge>=nodeCenter-2){step.classList.add('ej-step-active')}
        else{step.classList.remove('ej-step-active')}
      });
    }
    requestAnimationFrame(tick);
  }
  updateMobileTimelineLength();
  window.addEventListener('resize',updateMobileTimelineLength);
  if(document.fonts&&document.fonts.ready){document.fonts.ready.then(updateMobileTimelineLength)}
  new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        updateMobileTimelineLength();
        if(!running){running=true;requestAnimationFrame(tick)}
      }
    });
  },{threshold:0.2}).observe(track);
})();

/* ═══ PAGE I18N (shared by chat + contact form) ═══ */
var i18nEl=document.getElementById('wattson-i18n');
var I18N={};
try{I18N=i18nEl?JSON.parse(i18nEl.textContent):{};}catch(e){I18N={};}
var PAGE_FORM=I18N.form||{};
var PAGE_FORM_VAL=PAGE_FORM.validation||{};

/* ═══ WATTSON CHAT ═══ */
var msgs=document.getElementById('ejChatMsgs');
var input=document.getElementById('ejInput');
var sendBtn=document.getElementById('ejSend');
var typingEl=document.getElementById('ejTyping');
var recEl=document.getElementById('ejRec');
if(msgs&&input&&sendBtn&&typingEl&&recEl){

var WATTSON_IMG='https://cdn.shopify.com/s/files/1/0721/6644/1241/files/ChatGPT_Image_Jun_27_2026_05_15_47_PM.png?v=1782594985';
var WATTSON_API_BASE='https://wattson.ejscomputers.com/api/public';
var WATTSON_API_KEY='wpk_live_8d7b4f91a8c542e7b3f6c9d14a2e8f7157c4b91d3e6f8a2c5b7d9e1f4a6c8b2';

var CHAT=I18N.chat||{};
var MSG=CHAT.messages||{};
var REC=CHAT.recommendation||{};
var FORM_FILL=CHAT.quoteFormFill||{};
var LABELS=CHAT.labels||{};
var LOCALE=I18N.locale||'en';
var PRICE_LOCALE=CHAT.priceLocale||'en-CA';
var PRICE_CURRENCY=CHAT.priceCurrency||'CAD';
var mobileChatInitialRender=true;

function isMobileChat(){
  return window.matchMedia('(max-width:749px)').matches;
}

function getChatInputPlaceholder(){
  if(isMobileChat())return CHAT.inputPlaceholderMobile||CHAT.inputPlaceholder||'';
  return CHAT.inputPlaceholder||'';
}

function scrollChatToBottom(){
  if(msgs)msgs.scrollTop=msgs.scrollHeight;
}

function scrollChatToTop(){
  if(msgs)msgs.scrollTop=0;
}

function shouldSkipAutoScroll(){
  return isMobileChat()&&mobileChatInitialRender;
}

function finishInitialMobileChatRender(){
  if(!isMobileChat()||!mobileChatInitialRender)return;
  mobileChatInitialRender=false;
  requestAnimationFrame(function(){
    scrollChatToTop();
  });
}

input.placeholder=getChatInputPlaceholder();
window.addEventListener('resize',function(){
  if(input)input.placeholder=getChatInputPlaceholder();
});

var QUESTION_KEYS=['primaryUse','budget','cpuPreference','storage','aesthetics'];

var QUESTIONS=CHAT.questions||[];
var QUICK_RAW=CHAT.quick||[];
var QUICK=QUICK_RAW.map(function(group){return group.map(function(o){return o.label;});});
var QUICK_CANONICAL=QUICK_RAW.map(function(group){return group.map(function(o){return o.value;});});

function findQuickOption(text,questionIndex){
  var group=QUICK_RAW[questionIndex]||[];
  var i;
  for(i=0;i<group.length;i++){
    if(group[i].label===text||group[i].value===text)return group[i];
  }
  return null;
}

function quickValueToLabel(value,preferredIndex){
  var group,i,g;
  if(preferredIndex!=null){
    group=QUICK_RAW[preferredIndex]||[];
    for(i=0;i<group.length;i++){
      if(group[i].value===value)return group[i].label;
    }
  }
  for(g=0;g<QUICK_RAW.length;g++){
    group=QUICK_RAW[g]||[];
    for(i=0;i<group.length;i++){
      if(group[i].value===value)return group[i].label;
    }
  }
  return value;
}

function canonicalQuickOptions(index){
  return QUICK_CANONICAL[index]||[];
}

function labelsToCanonicalValue(labelsText,questionIndex){
  return labelsText.split(',').map(function(s){return s.trim();}).filter(Boolean).map(function(label){
    var match=findQuickOption(label,questionIndex);
    return match?match.value:label;
  }).join(', ');
}

function localizedAnswerDisplay(key,canonicalValue){
  if(!canonicalValue)return '';
  if(key==='cpuPreference'&&canonicalValue==='No preference')return FORM_FILL.noPreference||canonicalValue;
  if(key==='budget')return quickValueToLabel(canonicalValue,1)||canonicalValue;
  if(key==='primaryUse'&&canonicalValue.indexOf(',')>-1){
    return canonicalValue.split(',').map(function(v){return quickValueToLabel(v.trim(),0)||v.trim();}).join(', ');
  }
  var index=QUESTION_KEYS.indexOf(key);
  if(index>-1)return quickValueToLabel(canonicalValue,index)||canonicalValue;
  return canonicalValue;
}

function msgTemplate(template,vars){
  var out=template||'';
  if(vars){
    Object.keys(vars).forEach(function(k){
      out=out.split('{'+k+'}').join(vars[k]);
    });
  }
  return out;
}

function isOtherOrNotSureOption(opt){
  return opt===LABELS.other||opt===LABELS.notSure||opt==='Other'||opt==='Not sure';
}

var state={
  answers:{},
  questionCount:0,
  recommendationDone:false,
  lastRecommendedBuild:null,
  waiting:false,
  currentQuick:null,
  pendingRequests:0,
  conversationHistory:[],
  unclearAttempts:0
};

var BUDGET_TIERS=canonicalQuickOptions(1).filter(function(o){return o!=='Other';});

function normText(v){
  return (v||'').toLowerCase().replace(/\s+/g,' ').trim();
}

function pushConversation(role,text){
  state.conversationHistory.push({role:role,text:text});
  if(state.conversationHistory.length>8){
    state.conversationHistory.shift();
  }
}

function normalizeUpdateValue(key,value){
  if(key==='requestedGpuModel'||key==='requestedRamGb'||key==='minGpuTier'||key==='maxGpuTier')return value;
  if(key==='storage'){
    if(value==='1TB'||normText(value)==='1tb')return '1TB NVMe';
    if(value==='2TB'||normText(value)==='2tb')return '2TB NVMe';
    if(value==='4TB'||normText(value)==='4tb')return '4TB NVMe';
  }
  if(key==='cpuPreference'){
    if(value==='amd')return 'AMD';
    if(value==='intel')return 'Intel';
    if(value==='no-preference')return 'No preference';
  }
  return value;
}

function detectQuickOptionUpdates(text){
  var keys=['primaryUse','budget','cpuPreference','storage','aesthetics'];
  var i;
  for(i=0;i<QUICK_RAW.length;i++){
    var match=findQuickOption(text,i);
    if(!match)continue;
    if(match.value==='Other'||match.value==='Not sure')return null;
    var key=keys[i];
    var value=key==='storage'?normalizeUpdateValue('storage',match.value):match.value;
    if(!valuesDifferLocal(state.answers[key]||'',value,key))return null;
    var updates={};
    updates[key]=value;
    return updates;
  }
  return null;
}

function detectFollowupAnswerUpdates(text){
  if(isExplanationQuestion(text))return null;

  var updates={};
  var quick=detectQuickOptionUpdates(text);
  var local=detectLocalFollowupUpdates(text);

  if(quick)Object.keys(quick).forEach(function(k){updates[k]=quick[k];});
  if(local)Object.keys(local).forEach(function(k){updates[k]=local[k];});

  return Object.keys(updates).length?updates:null;
}

function showRestartDialog(){
  if(!restartDialog)return;
  restartDialog.classList.add('ej-show');
  restartDialog.setAttribute('aria-hidden','false');
}

function hideRestartDialog(){
  if(!restartDialog)return;
  restartDialog.classList.remove('ej-show');
  restartDialog.setAttribute('aria-hidden','true');
}

function resetConfigurator(){
  state.answers={};
  state.questionCount=0;
  state.recommendationDone=false;
  state.lastRecommendedBuild=null;
  state.unclearAttempts=0;
  state.waiting=false;
  state.pendingRequests=0;
  state.conversationHistory=[];

  clearQuick();
  typingEl.classList.remove('ej-show');

  recEl.classList.remove('ej-show');
  recEl.innerHTML='';

  var nodes=msgs.querySelectorAll('.ej-msg,.ej-quick-wrap');
  nodes.forEach(function(node){
    if(node.parentNode)node.parentNode.removeChild(node);
  });

  var comments=document.getElementById('ejComments');
  if(comments)comments.value='';

  input.value='';
  input.style.height='auto';
  input.placeholder=getChatInputPlaceholder();

  hideRestartDialog();

  mobileChatInitialRender=true;
  addMsg('assistant',MSG.welcome||'');
  presentQuestion(0,800);
}

function replyRestartConfigurator(){
  addMsg('assistant',MSG.restartConfigurator||'');
  clearQuick();
  setWaiting(false);
}

function isCheaperRequest(text){
  return /\b(cheaper|less expensive|lower price|lower the price|reduce (?:the )?budget|save money|make it cheaper|cost less)\b/i.test(text);
}

function detectGpuRejectModel(text){
  var v=text.toLowerCase();
  if(!/\b(?:don'?t need|do not need|without|skip|not worth|overkill|too much)\b/.test(v))return null;
  if(/\b5090\b/.test(v))return 'rtx5080';
  if(/\b5080\b/.test(v))return 'rtx5070ti';
  if(/\b5070\s*ti\b/.test(v))return 'rtx5070';
  return null;
}

function isGpuCheaperRequest(text){
  return /\b(cheaper|less expensive|lower|downgrade|save money|cost less)\b/i.test(text)&&
    /\b(gpu|graphics|video card|card|vram)\b/i.test(text);
}

function isExplanationQuestion(text){
  if(isComponentChangeRequest(text))return false;
  var v=normText(text);
  if(/\b(?:switch|change|want|need|take|instead)\b/.test(v)&&( /\b\d\s*tb\b/.test(v)||/\b(?:intel|amd)\b/.test(v)))return false;
  if(/\bhow much\b/.test(v)&&/\b(?:with|instead|5080|5090|5070|5060|5050|64\s*gb|128\s*gb|32\s*gb)\b/.test(v))return false;
  return /^(why|what|how|explain|tell me|can you explain|could you explain)\b/.test(v)||
    /\b(why|worth it|difference between|more vram|can this run|can it run)\b/.test(v);
}

function formatGpuModelLabel(model){
  if(model==='rtx5090')return 'RTX 5090';
  if(model==='rtx5080')return 'RTX 5080';
  if(model==='rtx5070ti')return 'RTX 5070 Ti';
  if(model==='rtx5070')return 'RTX 5070';
  if(model==='rtx5060ti')return 'RTX 5060 Ti';
  if(model==='rtx5060')return 'RTX 5060';
  if(model==='rtx5050')return 'RTX 5050';
  return String(model||'').toUpperCase();
}

function detectGpuModelUpdate(text){
  var v=text.replace(/\?/g,' ').trim();
  if(!/\b(gpu|graphics|video card|rtx|geforce|5080|5090|5070|5060|5050)\b/i.test(v))return null;
  if(!/\b(?:want|switch|change|swap|upgrade|downgrade|instead|with|use|take|put|get|choose|prefer|what if|how much|can you|could you|would it be|make it|go with|go for|rather|need|like to|recalculate|rebuild|update)\b/i.test(v)&&!/\brtx\s*\d{4}\b/i.test(v)&&!/\brtx\d{4}\b/i.test(v))return null;
  if(/\brtx\s*6090\b|\b6090\b/i.test(v))return null;
  if(/\brtx\s*5090\b|\brtx5090\b|\b5090\b/i.test(v))return 'rtx5090';
  if(/\brtx\s*5080\b|\brtx5080\b|\b5080\b/i.test(v))return 'rtx5080';
  if(/\brtx\s*5070\s*ti\b|\brtx5070ti\b|\b5070\s*ti\b/i.test(v))return 'rtx5070ti';
  if(/\brtx\s*5070\b|\brtx5070\b|\b5070\b(?!\s*ti\b)/i.test(v))return 'rtx5070';
  if(/\brtx\s*5060\s*ti\b|\brtx5060ti\b|\b5060\s*ti\b/i.test(v))return 'rtx5060ti';
  if(/\brtx\s*5060\b|\brtx5060\b|\b5060\b(?!\s*ti\b)/i.test(v))return 'rtx5060';
  if(/\brtx\s*5050\b|\brtx5050\b|\b5050\b/i.test(v))return 'rtx5050';
  return null;
}

function detectRamUpdate(text){
  var v=text.replace(/\?/g,' ').trim().toLowerCase();
  if(!/\b(ram|memory|ddr5|32\s*gb|64\s*gb|128\s*gb|128\s*g)\b/.test(v))return null;
  if(!/\b(?:want|switch|change|instead|with|use|take|what if|how much|can you|could you|64\s*gb|128\s*gb|32\s*gb|more ram|less ram)\b/.test(v))return null;
  if(/\b128\s*(?:gb|g)\b/.test(v))return '128';
  if(/\b64\s*gb\b/.test(v))return '64';
  if(/\b32\s*gb\b/.test(v))return '32';
  return null;
}

function detectRelativeRamUpdate(text,currentRamLabel){
  var v=text.toLowerCase();
  var currentGb=64;
  var match=(currentRamLabel||'').match(/\b(\d+)\s*gb\b/i);
  if(match)currentGb=parseInt(match[1],10);
  if(/\bmore ram\b/.test(v)){
    if(currentGb<=32)return '64';
    if(currentGb<=64)return '128';
    return '128';
  }
  if(/\bless ram\b/.test(v)){
    if(currentGb>=128)return '64';
    if(currentGb>=64)return '32';
    return '32';
  }
  return null;
}

function isGpuUpgradeRequest(text){
  return (/\b(upgrade|better|stronger|faster|more powerful|higher[- ]end|step up)\b/i.test(text)&&
    /\b(gpu|graphics|video card|card)\b/i.test(text))||/\bmore vram\b/i.test(text);
}

function parseGpuTierFromName(name){
  var v=normText(name||'');
  if(/\brtx\s*5090\b/.test(v))return 130;
  if(/\brtx\s*5080\b/.test(v))return 115;
  if(/\brtx\s*5070\s*ti\b/.test(v))return 105;
  if(/\brtx\s*5070\b/.test(v))return 95;
  if(/\brtx\s*5060\s*ti\b/.test(v))return 82;
  if(/\brtx\s*5060\b/.test(v))return 72;
  if(/\brtx\s*5050\b/.test(v))return 48;
  return 50;
}

function nextGpuTierUp(currentTier){
  var tiers=[48,72,82,95,105,115,130];
  var i;
  for(i=0;i<tiers.length;i++){
    if(tiers[i]>currentTier)return tiers[i];
  }
  return currentTier;
}

function isComponentChangeRequest(text){
  return detectGpuModelUpdate(text)||detectRamUpdate(text)||detectGpuUpgradeRequest(text);
}

function detectGpuUpgradeRequest(text){
  return isGpuUpgradeRequest(text);
}

function detectStorageUpdate(text){
  var v=normText(text);
  if(/\bmore storage\b/.test(v))return '4TB NVMe';
  if(/\bless storage\b/.test(v))return '1TB NVMe';
  if(/\b4\s*tb\b/.test(v))return '4TB NVMe';
  if(/\b2\s*tb\b/.test(v))return '2TB NVMe';
  if(/\b1\s*tb\b/.test(v))return '1TB NVMe';
  return null;
}

function detectCpuUpdate(text){
  var v=normText(text);
  if(/\bryzen[\dx\s-]*\d{4}\b/.test(v)||/\bryzen\b/.test(v))return 'AMD';
  if(/\b(?:keep|stay with|actually keep)\s+(?:the\s+)?amd\b/.test(v))return 'AMD';
  if(/\b(?:keep|stay with|actually keep)\s+(?:the\s+)?intel\b/.test(v))return 'Intel';
  if(/\b(?:want|need|switch|change|go with|prefer|take)\s+(?:to\s+)?intel\b/.test(v)||(/\band\s+intel\b/.test(v)))return 'Intel';
  if(/\b(?:want|need|switch|change|go with|prefer|take)\s+(?:to\s+)?amd\b/.test(v)||(/\band\s+amd\b/.test(v)))return 'AMD';
  if(/\bno preference\b/.test(v))return 'No preference';
  if(/\bintel\b/.test(v)&&/\b(?:instead|switch|change|want|and|,)\b/.test(v))return 'Intel';
  if(/\bamd\b/.test(v)&&/\b(?:instead|switch|change|want|and|keep|,)\b/.test(v))return 'AMD';
  return null;
}

function detectBudgetUpdate(text){
  var v=normText(text);
  var i;
  for(i=0;i<BUDGET_TIERS.length;i++){
    if(v.indexOf(normText(BUDGET_TIERS[i]))>-1)return BUDGET_TIERS[i];
  }
  return null;
}

function detectAestheticsUpdate(text){
  var v=normText(text);
  if(/\bno rgb\b/.test(v))return 'No RGB';
  if(/\brgb\b/.test(v)&&!/\bno rgb\b/.test(v))return 'RGB';
  if(/\bliquid cooling\b/.test(v))return 'Liquid cooling';
  if(/\bair cooling\b/.test(v))return 'Air cooling';
  if(/\bcompact workstation\b/.test(v))return 'Compact workstation';
  if(/\bfull-size workstation\b/.test(v))return 'Full-size workstation';
  return null;
}

function suggestLowerBudget(current){
  var idx=BUDGET_TIERS.indexOf(current);
  if(idx>0)return BUDGET_TIERS[idx-1];
  return null;
}

function valuesDifferLocal(current,next,key){
  if(!next)return false;
  if(key==='cpuPreference')return normText(current)!==normText(next);
  if(key==='storage'){
    return normText(current).replace(/nvme|ssd/g,'').trim()!==normText(next).replace(/nvme|ssd/g,'').trim();
  }
  return normText(current)!==normText(next);
}

function detectLocalFollowupUpdates(text){
  if(isExplanationQuestion(text))return null;

  var updates={};
  var storage=detectStorageUpdate(text);
  if(storage&&valuesDifferLocal(state.answers.storage||'',storage,'storage'))updates.storage=storage;

  var cpu=detectCpuUpdate(text);
  if(cpu&&valuesDifferLocal(state.answers.cpuPreference||'',cpu,'cpuPreference'))updates.cpuPreference=cpu;

  var budget=detectBudgetUpdate(text);
  if(budget&&state.answers.budget!==budget)updates.budget=budget;

  if(!updates.budget&&isCheaperRequest(text)){
    var lower=suggestLowerBudget(state.answers.budget||'');
    if(lower&&lower!==state.answers.budget)updates.budget=lower;
  }

  var aesthetics=detectAestheticsUpdate(text);
  if(aesthetics&&state.answers.aesthetics!==aesthetics)updates.aesthetics=aesthetics;

  var gpuReject=detectGpuRejectModel(text);
  if(gpuReject){
    updates.requestedGpuModel=gpuReject;
    updates.minGpuTier=undefined;
    updates.maxGpuTier=undefined;
  }else{
    var gpuModel=detectGpuModelUpdate(text);
    if(gpuModel&&state.answers.requestedGpuModel!==gpuModel){
      updates.requestedGpuModel=gpuModel;
      updates.minGpuTier=undefined;
      updates.maxGpuTier=undefined;
    }else if(detectGpuUpgradeRequest(text)&&state.lastRecommendedBuild){
      var currentGpu=state.lastRecommendedBuild.recommendedBuild&&state.lastRecommendedBuild.recommendedBuild.gpu;
      var gpuName=currentGpu&&(currentGpu.displayName||currentGpu.name)||'';
      var minTier=String(nextGpuTierUp(parseGpuTierFromName(gpuName)));
      if(state.answers.minGpuTier!==minTier){
        updates.minGpuTier=minTier;
        updates.requestedGpuModel=undefined;
        updates.maxGpuTier=undefined;
      }
    }else if(isGpuCheaperRequest(text)&&state.lastRecommendedBuild){
      var currentGpu2=state.lastRecommendedBuild.recommendedBuild&&state.lastRecommendedBuild.recommendedBuild.gpu;
      var gpuName2=currentGpu2&&(currentGpu2.displayName||currentGpu2.name)||'';
      var tiers=[48,72,82,95,105,115,130];
      var currentTier=parseGpuTierFromName(gpuName2);
      var maxTier=48;
      var i;
      for(i=0;i<tiers.length;i++){
        if(tiers[i]>=currentTier)break;
        maxTier=tiers[i];
      }
      updates.maxGpuTier=String(maxTier);
      updates.requestedGpuModel=undefined;
      updates.minGpuTier=undefined;
    }
  }

  var ramGb=detectRamUpdate(text);
  if(ramGb&&String(state.answers.requestedRamGb||'')!==ramGb){
    updates.requestedRamGb=ramGb;
  }else if(state.lastRecommendedBuild){
    var currentRam=state.lastRecommendedBuild.recommendedBuild&&state.lastRecommendedBuild.recommendedBuild.ram;
    var ramLabel=currentRam&&(currentRam.displayName||currentRam.name)||'';
    var relativeRam=detectRelativeRamUpdate(text,ramLabel);
    if(relativeRam&&String(state.answers.requestedRamGb||'')!==relativeRam)updates.requestedRamGb=relativeRam;
  }

  return Object.keys(updates).length?updates:null;
}

function isMultiSelect(index){
  return index===0||index===4;
}

function setWaiting(on){
  state.waiting=!!on;
}

function showTyping(){
  state.pendingRequests++;
  typingEl.classList.add('ej-show');
  if(!shouldSkipAutoScroll())scrollChatToBottom();
}

function hideTyping(){
  state.pendingRequests=Math.max(0,state.pendingRequests-1);
  if(state.pendingRequests===0){
    typingEl.classList.remove('ej-show');
  }
}

function wattsonPost(path,body){
  showTyping();
  return fetch(WATTSON_API_BASE+path,{
    method:'POST',
    headers:{
      'Content-Type':'application/json',
      'x-wattson-api-key':WATTSON_API_KEY
    },
    body:JSON.stringify(body)
  }).then(function(r){
    return r.json().then(function(data){
      if(!r.ok){
        var err=new Error(data&&data.error?data.error:(MSG.requestFailed||'Request failed'));
        err.status=r.status;
        err.payload=data;
        throw err;
      }
      return data;
    });
  }).finally(hideTyping);
}

function makeAvatar(role){
  var av=document.createElement('div');
  av.className='ej-msg-avatar '+(role==='assistant'?'ej-av-ai':'ej-av-user');
  if(role==='assistant'){
    var img=document.createElement('img');
    img.src=WATTSON_IMG;
    img.alt=(I18N.advisor&&I18N.advisor.chatName)||'Wattson';
    img.onerror=function(){av.textContent='🤖'};
    av.appendChild(img);
  }else{
    av.textContent='👤';
  }
  return av;
}

function addMsg(role,text){
  var wrap=document.createElement('div');
  wrap.className='ej-msg ej-msg-'+(role==='assistant'?'ai':'user');
  var bub=document.createElement('div');
  bub.className='ej-bubble ej-bubble-'+(role==='assistant'?'ai':'user');
  bub.textContent=text;
  wrap.appendChild(makeAvatar(role));
  wrap.appendChild(bub);
  msgs.insertBefore(wrap,typingEl);
  pushConversation(role,text);
  if(!shouldSkipAutoScroll())scrollChatToBottom();
}

function clearQuick(){
  if(state.currentQuick&&state.currentQuick.parentNode){
    state.currentQuick.parentNode.removeChild(state.currentQuick);
  }
  state.currentQuick=null;
}

function renderQuick(opts,multi){
  clearQuick();
  if(!opts||!opts.length)return;

  var wrap=document.createElement('div');
  wrap.className='ej-quick-wrap';
  var selected=[];

  opts.forEach(function(opt){
    var btn=document.createElement('button');
    var isOther=isOtherOrNotSureOption(opt);
    btn.className='ej-quick-btn'+(isOther?' ej-other':'');
    btn.textContent=opt;

    if(multi&&!isOther){
      btn.addEventListener('click',function(){
        var idx=selected.indexOf(opt);
        if(idx>-1){
          selected.splice(idx,1);
          btn.classList.remove('ej-selected');
        }else{
          selected.push(opt);
          btn.classList.add('ej-selected');
        }
        var conf=wrap.querySelector('.ej-quick-confirm');
        if(conf)conf.style.display=selected.length>0?'inline-block':'none';
      });
    }else{
      btn.addEventListener('click',function(){
        if(isOther&&!state.recommendationDone){
          input.focus();
          return;
        }
        processUserMessage(opt);
      });
    }

    wrap.appendChild(btn);
  });

  if(multi){
    var conf=document.createElement('button');
    conf.className='ej-quick-confirm';
    conf.textContent=LABELS.confirm||'Confirm →';
    conf.style.display='none';
    conf.addEventListener('click',function(){
      if(selected.length){
        var display=selected.join(', ');
        processUserMessage(display,labelsToCanonicalValue(display,0));
      }
    });
    wrap.appendChild(conf);
  }

  msgs.insertBefore(wrap,typingEl);
  state.currentQuick=wrap;
  if(shouldSkipAutoScroll()){
    finishInitialMobileChatRender();
  }else{
    setTimeout(scrollChatToBottom,50);
  }
}

function parseBudget(v){
  v=(v||'').toLowerCase();

  if(v.indexOf('12,000+')>-1||v.indexOf('12000+')>-1||v.indexOf('$12,000+')>-1)return 16000;
  if(v.indexOf('3,000')>-1&&v.indexOf('5,000')>-1)return 5000;
  if(v.indexOf('5,000')>-1&&v.indexOf('8,000')>-1)return 8000;
  if(v.indexOf('8,000')>-1&&v.indexOf('12,000')>-1)return 12000;

  if(v.indexOf('12000')>-1)return 16000;
  if(v.indexOf('8000')>-1)return 12000;
  if(v.indexOf('5000')>-1)return 8000;
  if(v.indexOf('3000')>-1)return 5000;

  var m=v.match(/\d[\d,]*/);
  return m?parseInt(m[0].replace(/,/g,''),10):5000;
}

function normCpu(v){
  v=(v||'').toLowerCase();
  if(v.indexOf('amd')>-1)return 'amd';
  if(v.indexOf('intel')>-1)return 'intel';
  return 'no-preference';
}

function itemName(item){
  if(!item)return MSG.toBeConfirmed||'To be confirmed';
  return item.displayName||item.name||MSG.toBeConfirmed||'To be confirmed';
}

function itemReason(item){
  if(!item)return MSG.itemReasonDefault||'';
  if(item.customerDescription)return item.customerDescription;
  return MSG.itemReasonDefault||'';
}

function formatPrice(value){
  if(value===null||value===undefined||value==='')return MSG.toBeConfirmed||'To be confirmed';
  if(typeof value==='string')return value.replace(/\u2248|≈/g,'~');

  if(typeof value==='number'){
    return '~ $'+Math.round(value).toLocaleString(PRICE_LOCALE)+' '+PRICE_CURRENCY;
  }

  if(typeof value==='object'){
    if(value.label)return String(value.label).replace(/\u2248|≈/g,'~');
    if(value.formatted)return String(value.formatted).replace(/\u2248|≈/g,'~');

    if(value.min||value.max){
      var price=Math.round(value.min||value.max||0);
      return '~ $'+price.toLocaleString(PRICE_LOCALE)+' '+(value.currency||PRICE_CURRENCY);
    }
  }

  return MSG.toBeConfirmed||'To be confirmed';
}

function logPricingBreakdown(data){
  var breakdown=data&&data.pricingBreakdown;
  if(!breakdown||!breakdown.lines||!breakdown.lines.length)return;

  var lines=['[Wattson pricing breakdown]'];
  breakdown.lines.forEach(function(line){
    lines.push((line.label||'Component')+': $'+(line.supplierCostCad||0).toLocaleString('en-CA')+' CAD (supplier)');
  });
  lines.push('');
  lines.push('Component subtotal: $'+(breakdown.componentSubtotalCad||0).toLocaleString('en-CA')+' CAD');
  lines.push('Fixed support costs: $'+(breakdown.fixedCostsCad||0).toLocaleString('en-CA')+' CAD');
  lines.push('Supplier subtotal: $'+(breakdown.supplierSubtotalCad||0).toLocaleString('en-CA')+' CAD');
  lines.push('Margin: '+Math.round((breakdown.marginPercent||0)*100)+'%');
  lines.push('Estimated build price: $'+(breakdown.estimatedCustomerPriceCad||0).toLocaleString('en-CA')+' CAD');
  lines.push('Displayed estimated price: $'+(data.estimatedPrice!=null?data.estimatedPrice:breakdown.estimatedCustomerPriceCad).toLocaleString('en-CA')+' CAD');
  console.log(lines.join('\n'));
}

function resolveEstimatedPrice(data){
  if(!data)return null;
  if(data.pricingBreakdown&&data.pricingBreakdown.estimatedCustomerPriceCad!=null){
    return data.pricingBreakdown.estimatedCustomerPriceCad;
  }
  if(data.estimatedPrice!=null)return data.estimatedPrice;
  if(data.estimatedPriceRange&&data.estimatedPriceRange.min!=null)return data.estimatedPriceRange.min;
  return data.estimatedPriceLabel||null;
}

function buildPayload(){
  var use=(state.answers.primaryUse||'').toLowerCase();
  var budgetText=state.answers.budget||'';

  var localModels='Not specified';
  if(use.indexOf('llm')>-1||use.indexOf('local ai')>-1||use.indexOf('model')>-1||use.indexOf('training')>-1||use.indexOf('fine')>-1){
    localModels='Yes, local AI models';
  }

  var generation='Not specified';
  if(use.indexOf('image')>-1)generation='AI image generation';
  if(use.indexOf('video')>-1)generation='AI video generation';

  return {
    advisorType:'ai-workstation',
    locale:LOCALE,
    answers:{
      primaryUse:state.answers.primaryUse||'',
      budget:budgetText,
      budgetText:budgetText,
      budgetLabel:budgetText,
      budgetMax:parseBudget(budgetText),
      localModels:localModels,
      generation:generation,
      cpuPreference:normCpu(state.answers.cpuPreference),
      gpuPreference:'nvidia',
      storage:state.answers.storage||'',
      aesthetics:state.answers.aesthetics||''
    }
  };
}

function buildFollowupPayload(userText){
  return {
    advisorType:'ai-workstation',
    locale:LOCALE,
    currentAnswers:state.answers,
    currentBuild:state.lastRecommendedBuild,
    userText:userText,
    conversationHistory:state.conversationHistory.slice(-6),
    unclearAttemptCount:state.unclearAttempts,
    availableOptions:{
      budget:canonicalQuickOptions(1),
      cpuPreference:canonicalQuickOptions(2),
      storage:canonicalQuickOptions(3),
      primaryUse:canonicalQuickOptions(0),
      aesthetics:canonicalQuickOptions(4)
    }
  };
}

function updateQuoteForm(build,price){
  var cpu=build.cpu||{};
  var gpu=build.gpu||{};
  var ram=build.ram||{};
  var storage=build.storage||{};

  var txt=(FORM_FILL.preferencesHeader||'')+'\n';
  txt+=(FORM_FILL.primaryUse||'Primary Use')+': '+localizedAnswerDisplay('primaryUse',state.answers.primaryUse||'')+'\n';
  txt+=(FORM_FILL.budget||'Budget')+': '+localizedAnswerDisplay('budget',state.answers.budget||'')+'\n';
  txt+=(FORM_FILL.cpuPreference||'CPU Preference')+': '+localizedAnswerDisplay('cpuPreference',state.answers.cpuPreference||FORM_FILL.noPreference||'No preference')+'\n';
  txt+=(FORM_FILL.storage||'Storage')+': '+localizedAnswerDisplay('storage',state.answers.storage||'')+'\n';
  txt+=(FORM_FILL.aesthetics||'Aesthetics / Cooling')+': '+localizedAnswerDisplay('aesthetics',state.answers.aesthetics||'')+'\n\n';

  txt+=(FORM_FILL.buildHeader||'')+'\n';
  txt+=(FORM_FILL.cpu||'CPU')+': '+itemName(cpu)+'\n';
  txt+=(FORM_FILL.gpu||'GPU')+': '+itemName(gpu)+'\n';
  txt+=(FORM_FILL.ram||'RAM')+': '+itemName(ram)+'\n';
  txt+=(FORM_FILL.storage||'Storage')+': '+itemName(storage)+'\n';
  txt+=(FORM_FILL.estimatedPrice||'Estimated Price')+': '+price;

  var comments=document.getElementById('ejComments');
  if(comments)comments.value=txt;
}

function recIcon(type){
  var icons={
    cpu:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="8" y="8" width="8" height="8" rx="1.4"/><path stroke-linecap="round" d="M10 8V6M14 8V6M10 16v2M14 16v2M8 10H6M8 14H6M16 10h2M16 14h2"/></svg>',
    gpu:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="5" y="8" width="14" height="8" rx="2"/><path stroke-linecap="round" d="M8 16v2M16 16v2"/><path stroke-linecap="round" d="M9 11h2M13 11h2"/></svg>',
    ram:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="4" y="9" width="16" height="6" rx="1.4"/><path stroke-linecap="round" d="M7 12h2M11 12h2M15 12h2"/></svg>',
    storage:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><ellipse cx="12" cy="8" rx="7" ry="3"/><path d="M5 8v8c0 1.7 3.1 3 7 3s7-1.3 7-3V8"/><path stroke-linecap="round" d="M5 12c0 1.7 3.1 3 7 3s7-1.3 7-3"/></svg>'
  };
  return icons[type]||icons.cpu;
}

function buildRecComponent(type,label,item,delay){
  var why=itemReason(item);
  var whyHtml=why?'<p class="ej-rec-why">'+why+'</p>':'';
  return '<article class="ej-rec-item" style="--ej-rec-delay:'+delay+'ms">'+
    '<span class="ej-rec-icon">'+recIcon(type)+'</span>'+
    '<div class="ej-rec-item-body">'+
      '<span class="ej-rec-label">'+label+'</span>'+
      '<p class="ej-rec-value">'+itemName(item)+'</p>'+
      whyHtml+
    '</div>'+
  '</article>';
}

function showRec(data){
  data=data||{};
  var build=data.recommendedBuild||{};
  logPricingBreakdown(data);
  var priceValue=resolveEstimatedPrice(data);
  var price=formatPrice(priceValue);

  var cpu=build.cpu||{};
  var gpu=build.gpu||{};
  var ram=build.ram||{};
  var storage=build.storage||{};

  recEl.classList.remove('ej-show');
  recEl.innerHTML=
    '<span class="ej-rec-gutter" aria-hidden="true"></span>'+
    '<div class="ej-rec-inner">'+
      '<header class="ej-rec-head">'+
        '<div class="ej-rec-head-top">'+
          '<h3 class="ej-rec-title">'+(REC.title||'')+'</h3>'+
          '<span class="ej-rec-verified">'+
            '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.5 6l2.2 2.2L9.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'+
            (REC.verified||'')+
          '</span>'+
        '</div>'+
        '<p class="ej-rec-subtitle">'+(REC.subtitle||'')+'</p>'+
      '</header>'+
      '<div class="ej-rec-grid">'+
        buildRecComponent('cpu',REC.cpu||'CPU',cpu,80)+
        buildRecComponent('gpu',REC.gpu||'GPU',gpu,130)+
        buildRecComponent('ram',REC.ram||'RAM',ram,180)+
        buildRecComponent('storage',REC.storage||'Storage',storage,230)+
      '</div>'+
      '<div class="ej-rec-foot">'+
        '<div class="ej-rec-price">'+
          '<div class="ej-rec-price-row">'+
            '<span class="ej-rec-price-label">'+(REC.priceLabel||'')+'</span>'+
            '<span class="ej-rec-price-val">'+price+'</span>'+
          '</div>'+
          '<p class="ej-rec-price-note">'+(REC.priceNote||'')+'</p>'+
        '</div>'+
        '<button type="button" class="ej-rec-quote ej-submit" id="ejRecQuoteBtn">'+
          '<span class="ej-rec-quote-text">'+(REC.quoteBtn||'')+'</span>'+
          '<span class="ej-rec-quote-arrow" aria-hidden="true">'+
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'+
          '</span>'+
        '</button>'+
        '<div class="ej-rec-restart">'+
          '<p class="ej-rec-restart-note">'+(REC.restartNote||'')+'</p>'+
          '<button type="button" class="ej-rec-restart-btn" id="ejRecRestartBtn">'+(REC.restartBtn||'')+'</button>'+
        '</div>'+
      '</div>'+
    '</div>';
  recEl.classList.add('ej-show');
  if(msgs&&!shouldSkipAutoScroll())scrollChatToBottom();

  updateQuoteForm(build,price);
}

function callWattson(){
  setWaiting(true);

  return wattsonPost('/workstation-recommendation',buildPayload())
    .then(function(data){
      state.lastRecommendedBuild=data;
      state.recommendationDone=true;
      clearQuick();

      addMsg('assistant',MSG.recommendationReady||'');

      showRec(data);
      if(msgs&&!shouldSkipAutoScroll())scrollChatToBottom();
      setWaiting(false);
    })
    .catch(function(err){
      console.error('Wattson API error:',err);
      addMsg('assistant',MSG.recommendationError||'');
      setWaiting(false);
    });
}

function presentQuestion(index,delay,unlockAfter){
  var wait=delay||0;
  setTimeout(function(){
    addMsg('assistant',QUESTIONS[index]);
    renderQuick(QUICK[index],isMultiSelect(index));
    if(unlockAfter){
      setWaiting(false);
    }
  },wait);
}

function advanceQuestionnaire(value){
  var key=QUESTION_KEYS[state.questionCount];
  if(key){
    state.answers[key]=value;
  }
  state.questionCount++;

  if(state.questionCount<QUESTIONS.length){
    presentQuestion(state.questionCount,300,true);
    return;
  }

  callWattson();
}

function clarifyDuringQuestionnaire(text){
  var key=QUESTION_KEYS[state.questionCount];

  wattsonPost('/chatbot-clarify',{
    advisorType:'ai-workstation',
    locale:LOCALE,
    questionKey:key,
    questionText:QUESTIONS[state.questionCount],
    userText:text,
    validOptions:canonicalQuickOptions(state.questionCount)
  })
  .then(function(result){
    if(result&&result.shouldAdvance){
      advanceQuestionnaire(result.normalizedValue||text);
      return;
    }

    if(result&&result.message){
      addMsg('assistant',result.message);
    }

    renderQuick(QUICK[state.questionCount],isMultiSelect(state.questionCount));
    setWaiting(false);
  })
  .catch(function(err){
    console.error('Wattson clarify error:',err);
    addMsg('assistant',msgTemplate(MSG.clarifyFallback,{question:QUESTIONS[state.questionCount]}));
    renderQuick(QUICK[state.questionCount],isMultiSelect(state.questionCount));
    setWaiting(false);
  });
}

function applyFollowupAction(result){
  if(result.action==='update-and-recommend'){
    replyRestartConfigurator();
    return;
  }

  if(result.action==='ask-clarification'){
    if(result.unclear){
      state.unclearAttempts++;
    }else if(result.quickOptions&&result.quickOptions.length){
      state.unclearAttempts=0;
    }
    renderQuick((result.quickOptions||[]).map(function(v){return quickValueToLabel(v)||v;}),false);
    setWaiting(false);
    return;
  }

  state.unclearAttempts=0;
  clearQuick();
  setWaiting(false);
}

function processFollowup(text){
  if(!state.lastRecommendedBuild){
    addMsg('assistant',MSG.noRecommendationYet||'');
    setWaiting(false);
    return;
  }

  var updates=detectFollowupAnswerUpdates(text);
  if(updates){
    replyRestartConfigurator();
    return;
  }

  wattsonPost('/chatbot-followup',buildFollowupPayload(text))
    .then(function(result){
      if(result&&result.message){
        addMsg('assistant',result.message);
      }

      if(result&&result.action){
        applyFollowupAction(result);
        return;
      }

      setWaiting(false);
    })
    .catch(function(err){
      console.error('Wattson followup error:',err);
      addMsg('assistant',err&&err.message?err.message:(MSG.followupError||''));
      setWaiting(false);
    });
}

function processUserMessage(text,answerValue){
  if(state.waiting)return;

  text=(text||'').trim();
  if(!text)return;

  setWaiting(true);
  addMsg('user',text);
  clearQuick();

  if(state.recommendationDone){
    processFollowup(text);
    return;
  }

  if(answerValue){
    advanceQuestionnaire(answerValue);
    return;
  }

  var quickMatch=findQuickOption(text,state.questionCount);
  if(quickMatch){
    advanceQuestionnaire(quickMatch.value);
    return;
  }

  clarifyDuringQuestionnaire(text);
}

recEl.addEventListener('click',function(e){
  var btn=e.target.closest('#ejRecQuoteBtn');
  if(btn){
    var el=document.getElementById('ej-contact');
    if(el)el.scrollIntoView({behavior:'smooth',block:'start'});
    return;
  }
  if(e.target.closest('#ejRecRestartBtn')){
    showRestartDialog();
  }
});

var restartDialog=document.getElementById('ejRestartDialog');
var restartCancelBtn=document.getElementById('ejRestartCancelBtn');
var restartConfirmBtn=document.getElementById('ejRestartConfirmBtn');

if(restartCancelBtn){
  restartCancelBtn.addEventListener('click',hideRestartDialog);
}
if(restartConfirmBtn){
  restartConfirmBtn.addEventListener('click',resetConfigurator);
}
if(restartDialog){
  restartDialog.addEventListener('click',function(e){
    if(e.target===restartDialog)hideRestartDialog();
  });
}

/* Start chat */
setTimeout(function(){
  mobileChatInitialRender=true;
  addMsg('assistant',MSG.welcome||'');
  presentQuestion(0,800);
},800);

var advisorEl=document.getElementById('ej-advisor');
if(advisorEl){
  new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting||!isMobileChat())return;
      if(mobileChatInitialRender&&msgs&&msgs.querySelector('.ej-quick-wrap')){
        finishInitialMobileChatRender();
      }
    });
  },{threshold:0.15}).observe(advisorEl);
}

sendBtn.addEventListener('click',function(){
  var t=input.value.trim();
  if(!t)return;
  input.value='';
  input.style.height='auto';
  processUserMessage(t);
});

input.addEventListener('keydown',function(e){
  if(e.key==='Enter'&&!e.shiftKey){
    e.preventDefault();
    sendBtn.click();
  }
});

input.addEventListener('input',function(){
  input.style.height='auto';
  input.style.height=Math.min(input.scrollHeight,120)+'px';
});

}

/* ═══ CONTACT FORM ═══ */
(function(){
  var form=document.getElementById('ejContactForm');
  var success=document.getElementById('ejFormSuccess');
  if(!form||!success)return;

  var FORM=PAGE_FORM;
  var FORM_VAL=PAGE_FORM_VAL;

  function clearFieldValidity(field){
    if(field)field.setCustomValidity('');
  }

  function failField(field,message){
    if(!field)return false;
    field.setCustomValidity(message||'');
    field.reportValidity();
    field.focus();
    return false;
  }

  function isValidEmail(value){
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function validateContactForm(){
    var fname=document.getElementById('ejFname');
    var lname=document.getElementById('ejLname');
    var email=document.getElementById('ejEmail');
    var phone=document.getElementById('ejPhone');

    clearFieldValidity(fname);
    clearFieldValidity(lname);
    clearFieldValidity(email);
    clearFieldValidity(phone);

    if(!fname||!fname.value.trim()){
      return failField(fname,FORM_VAL.firstNameRequired);
    }
    if(!lname||!lname.value.trim()){
      return failField(lname,FORM_VAL.lastNameRequired);
    }
    if(!email||!email.value.trim()){
      return failField(email,FORM_VAL.emailRequired);
    }
    if(!isValidEmail(email.value.trim())){
      return failField(email,FORM_VAL.emailInvalid);
    }
    if(!phone||!phone.value.trim()){
      return failField(phone,FORM_VAL.phoneRequired);
    }

    return true;
  }

  [document.getElementById('ejFname'),document.getElementById('ejLname'),document.getElementById('ejEmail'),document.getElementById('ejPhone')].forEach(function(field){
    if(!field)return;
    field.addEventListener('input',function(){clearFieldValidity(field);});
  });

  success.style.display='none';
  form.addEventListener('submit',function(e){
    if(!validateContactForm()){
      e.preventDefault();
      return;
    }
    sessionStorage.setItem('ejFormSubmitted','1');
  });
  if(sessionStorage.getItem('ejFormSubmitted')==='1'){
    sessionStorage.removeItem('ejFormSubmitted');
    form.style.display='none';
    success.style.display='block';
    setTimeout(function(){
      var el=document.getElementById('ejFormSuccess');
      if(el)el.scrollIntoView({behavior:'smooth',block:'center'});
    },200);
  }
})();

})();
